/**
 * ID Converter Utility
 * 將數字 ID 轉換為6-8碼字母數字顯示格式
 */


/**
 * 將數字 ID 轉換為6-8碼字母數字顯示格式
 * @param {number|string} id - 節點 ID（正整數或數字字符串）
 * @returns {string} 6-8碼的字母數字格式 ID
 * 
 * @example
 * convertIdToAlphanumeric(1)        // '000001'
 * convertIdToAlphanumeric('1')      // '000001'
 * convertIdToAlphanumeric(100)      // '00002S'
 * convertIdToAlphanumeric('100')    // '00002S'
 * convertIdToAlphanumeric(1000)     // '0000RS'
 * convertIdToAlphanumeric(10000)    // '0007PS'
 * convertIdToAlphanumeric(1000000)  // '00LFLS'
 */
export function convertIdToAlphanumeric(id) {
  // 處理 null 和 undefined
  if (id === null || id === undefined) {
    return '000000';
  }

  // 如果是字符串，先驗證格式再轉換
  let numericId = id;
  if (typeof id === 'string') {
    // 去除前後空格
    const trimmed = id.trim();
    // 檢查是否為純數字（不允許小數點、負號等）
    if (!/^\d+$/.test(trimmed)) {
      return '000000';
    }
    numericId = parseInt(trimmed, 10);
  }

  // 驗證是否為有效的正整數
  if (typeof numericId !== 'number' || isNaN(numericId) || numericId < 1 || !Number.isInteger(numericId)) {
    return '000000';
  }

  // 轉換為 base36（0-9, a-z），然後轉大寫
  let base36 = numericId.toString(36).toUpperCase();
  
  // 如果超過 8 碼，只取後 8 碼
  if (base36.length > 8) {
    base36 = base36.slice(-8);
  }
  
  // 如果不足 6 碼，在前面補 0
  if (base36.length < 6) {
    base36 = base36.padStart(6, '0');
  }
  
  return base36;
}

// 為了向後兼容，保留舊的函數名作為別名
export const convertIdToAlphabet = convertIdToAlphanumeric;
